import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "../../components/ui/dialog";
import { ManageTablesTab } from "../organization-settings/tabs/manage-tables-tab/manage-tables.tab";

export const TableSettingsDialog: React.FC<{
	open: boolean;
	onClose: () => void;
}> = ({ open, onClose }) => {
	return (
		<Dialog open={open} onOpenChange={onClose}>
			<DialogContent className="sm:max-w-2xl max-h-[80vh] flex flex-col">
				<DialogHeader>
					<DialogTitle>Tabelleneinstellungen</DialogTitle>
					<DialogDescription>
						Wählen Sie aus, welche Spalten in der Positionstabelle angezeigt werden sollen.
					</DialogDescription>
				</DialogHeader>
				<ManageTablesTab onClose={onClose} />
			</DialogContent>
		</Dialog>
	);
};